import { DomainCode } from '@australiangreens/ag-internal-components';
import { logger } from '@/util';
import callBackendApi from './call';

export interface MailingRecord {
  id: number;
  name: string;
  scheduledDate: string;
}

export const getMailingsContaining = async (
  token: string,
  containedString: string,
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getMailingsContaining() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/mailings/containing/${encodeURIComponent(
      containedString
    )}?domainCode=${domainCode}`,
    abortSignal,
  });
  return data as MailingRecord[];
};

export const getMailingsByIds = async (token: string, ids: number[], abortSignal?: AbortSignal) => {
  logger.debug('getMailingsByIds() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/mailings?ids=${JSON.stringify(ids)}`,
    abortSignal,
  });
  return data as MailingRecord[];
};
